import {CSSProperties} from "react";

export default function Radio({
                                  checked = false,
                                  onChange,
                                  size = 24,
                                  color = "#FC802D",
                                  className = "",
                                  style = {}
                              }: {
    checked?: boolean,
    onChange?: () => void
    size?: number,
    color?: string,
    className?: string,
    style?: CSSProperties
}) {
    return <div onClick={onChange} className={`matchid-radio ${className} ${checked ? 'matchid-radio-checked' :''}`} style={{
        width: size,
        height: size,
        ...style,
        // @ts-ignore
        '--matchid-radio-checked': color
    }}>
        {checked && <div className={`matchid-radio-content`} style={{
            width:Math.floor(size*0.7),
            height:Math.floor(size*0.7),
        }}></div>}
    </div>
}